import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAuthState, useSignInWithEmailAndPassword } from 'react-firebase-hooks/auth';
import auth from '../firebase.init';
import Loading from '../Shared/Loading';
import { toast } from 'react-toastify';


const SignIn = () => {

    const [errorMessage, setErrorMessage] = useState('');
    const [signInuser, loadingUser] = useAuthState(auth);
    const navigate = useNavigate();
    let location = useLocation();
    let from = location.state?.from?.pathname || "/";

    const { register, formState: { errors }, handleSubmit, reset } = useForm();
    const [
        signInWithEmailAndPassword,
        user,
        loading,
        error
    ] = useSignInWithEmailAndPassword(auth);



    // navigate to home page 
    if (signInuser || user) {
        navigate(from, { replace: true })
    }


    if (loading || loadingUser) {
        return <Loading />
    }

    const onSubmit = data => {
        setErrorMessage(error?.message)
        signInWithEmailAndPassword(data?.email, data?.password);
        if (user) {
            toast.success('Sign In successfully!!')
        }
        
        reset();
    }


    return (
        <div className='flex items-center justify-center  md:h-[80vh] h-screen'>
            <div className="card mx-auto md:w-96 w-5/6 bg-base-100  shadow-xl">
                <div className="card-body">
                    <h2 className='uppercase text-center font-bold text-2xl mb-4'>Sign in</h2>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="form-control w-full ">
                            <input
                                type="email"
                                placeholder="Email"
                                className="input input-bordered w-full  "
                                {...register("email", {
                                    required: {
                                        value: true,
                                        message: "Email is required"
                                    },
                                    pattern: {
                                        value: /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/,
                                        message: "Provide a valid Email!"
                                    }
                                })}
                            />
                            <label className="label">
                                {errors.email?.type === 'required' && <span className="label-text-alt text-red-500">{errors.email.message}</span>}
                                {errors.email?.type === 'pattern' && <span className="label-text-alt text-red-500">{errors.email.message}</span>}
                            </label>


                            <input
                                type="password"
                                placeholder="Password"
                                className="input input-bordered w-full"
                                {...register("password", {
                                    required: {
                                        value: true,
                                        message: "Password is required"
                                    },
                                    pattern: {
                                        value: /[0-9a-zA-Z]{6,}/,
                                        message: "Password should 6 characters or longer!"
                                    }
                                })}
                            />
                            <label className="label">
                                {errors.password?.type === 'required' && <span className="label-text-alt text-red-500">{errors.password.message}</span>}
                                {errors.password?.type === 'pattern' && <span className="label-text-alt text-red-500">{errors.password.message}</span>}
                            </label>
                        </div>
                        <p className='mb-1 text-red-500 text-center font-semibold capitalize '>{errorMessage?.slice(22, 36)}</p>
                        <h2 className='text-md mb-3  text-gray-500'>Forgot Password? <span className='text-green-500'><Link to='/fmresetpassword' >Reset Password</Link></span></h2>
                        <button type='submit' className='btn w-full border-0 text-white bg-green-500' >Sign In  <FontAwesomeIcon className='ml-2' icon={faArrowRight}></FontAwesomeIcon> </button>
                        <div className='mt-3'>
                            <span className='text-md mt-5  text-gray-500'>Don't have and Account? <span className='text-green-500'><Link to='/father' >Sing Up</Link></span></span>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};


export default SignIn;